document.addEventListener('DOMContentLoaded', function() {
  const timelineSections = document.querySelectorAll('.age-timeline-section');

  function setUrlParam(key, value) {
    const url = new URL(window.location);
    if (value && value !== 'all') {
      url.searchParams.set(key, value);
    } else {
      url.searchParams.delete(key);
    }
    window.history.replaceState({}, '', url);
  }

  function getProductsToShow(section) {
    return parseInt(section.getAttribute('data-products-to-show'), 10) || 24;
  }

  function normalizeTag(value) {
    return (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  function productMatchesFilter(product, filter) {
    if (!filter || filter === 'all') return true;

    const normalizedFilter = normalizeTag(filter);
    const tags = product.getAttribute('data-tags') || '';
    const tagsArray = tags.split(',').map(tag => normalizeTag(tag));

    return tagsArray.includes(normalizedFilter);
  }

  function updateLoadMoreState(pane) {
    const grid = pane.querySelector('[data-products-grid]');
    const wrapper = pane.querySelector('.age-pane__load-more-wrapper');

    if (!grid || !wrapper) return;

    const hasHiddenOverflow = Boolean(pane.querySelector('.age-pane__product-item.is-age-overflow'));
    const hasNextPage = Boolean(grid.getAttribute('data-next-page'));
    const isLoading = pane.getAttribute('data-loading-products') === 'true';

    wrapper.hidden = isLoading || (!hasHiddenOverflow && !hasNextPage);
  }

  function updateVisibleProducts(pane) {
    const section = pane.closest('.age-timeline-section');
    const filter = pane.getAttribute('data-active-filter') || 'all';
    const visibleLimit = parseInt(pane.getAttribute('data-visible-count'), 10) || getProductsToShow(section);
    const products = Array.from(pane.querySelectorAll('.age-pane__product-item[data-age-product="true"]'));
    let matchingIndex = 0;

    products.forEach(product => {
      const matchesFilter = productMatchesFilter(product, filter);

      product.classList.toggle('is-hidden', !matchesFilter);

      if (!matchesFilter) {
        product.classList.remove('is-age-overflow');
        return;
      }

      matchingIndex += 1;
      product.classList.toggle('is-age-overflow', matchingIndex > visibleLimit);
    });

    updateLoadMoreState(pane);
  }

  function getVisibleMatchingCount(pane) {
    const filter = pane.getAttribute('data-active-filter') || 'all';
    const products = Array.from(pane.querySelectorAll('.age-pane__product-item[data-age-product="true"]'));

    return products.filter(product => productMatchesFilter(product, filter)).length;
  }

  function updateFilterAvailability(pane) {
    const filterBtns = Array.from(pane.querySelectorAll('.age-pane__subcat-btn'));
    const products = Array.from(pane.querySelectorAll('.age-pane__product-item[data-age-product="true"]'));

    filterBtns.forEach(btn => {
      const filter = btn.getAttribute('data-filter');

      if (!filter || filter === 'all') {
        btn.hidden = false;
        return;
      }

      btn.hidden = !products.some(product => productMatchesFilter(product, filter));
    });
  }

  async function loadNextProductsPage(section, pane) {
    const grid = pane.querySelector('[data-products-grid]');
    const sectionId = section.getAttribute('data-section-id');
    const nextPage = grid ? grid.getAttribute('data-next-page') : '';

    if (!grid || !sectionId || !nextPage || pane.getAttribute('data-loading-products') === 'true') return false;

    pane.setAttribute('data-loading-products', 'true');
    updateLoadMoreState(pane);

    const loading = pane.querySelector('.age-pane__loading');
    if (loading) loading.hidden = false;

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', sectionId);
      url.searchParams.set('page', nextPage);

      const response = await fetch(url.toString(), { credentials: 'same-origin' });
      if (!response.ok) {
        grid.removeAttribute('data-next-page');
        return false;
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const ageSlug = pane.getAttribute('data-age-slug');
      const nextPane = doc.querySelector(`.age-timeline__tab-pane[data-age-slug="${ageSlug}"]`);
      const nextGrid = nextPane ? nextPane.querySelector('[data-products-grid]') : null;

      if (!nextGrid) {
        grid.removeAttribute('data-next-page');
        return false;
      }

      const nextProducts = Array.from(nextGrid.querySelectorAll('.age-pane__product-item[data-age-product="true"]'));

      nextProducts.forEach(product => {
        product.classList.remove('is-hidden', 'is-age-overflow');
        grid.appendChild(product);
      });

      const followingPage = nextGrid.getAttribute('data-next-page');
      if (followingPage) {
        grid.setAttribute('data-next-page', followingPage);
      } else {
        grid.removeAttribute('data-next-page');
      }

      return true;
    } catch (error) {
      console.error('Could not load age products', error);
      grid.removeAttribute('data-next-page');
      return false;
    } finally {
      pane.removeAttribute('data-loading-products');
      if (loading) loading.hidden = true;
      updateFilterAvailability(pane);
      updateVisibleProducts(pane);
    }
  }

  async function revealMoreProducts(section, pane) {
    const step = getProductsToShow(section);
    const currentVisibleCount = parseInt(pane.getAttribute('data-visible-count'), 10) || step;

    pane.setAttribute('data-visible-count', String(currentVisibleCount + step));
    updateVisibleProducts(pane);

    const grid = pane.querySelector('[data-products-grid]');

    if (!pane.querySelector('.age-pane__product-item.is-age-overflow') && grid && grid.getAttribute('data-next-page')) {
      await ensureVisibleProducts(section, pane);
    }
  }

  async function ensureVisibleProducts(section, pane) {
    const grid = pane.querySelector('[data-products-grid]');

    if (!grid || pane.getAttribute('data-loading-products') === 'true') return;

    let visibleLimit = parseInt(pane.getAttribute('data-visible-count'), 10) || getProductsToShow(section);

    while (grid.getAttribute('data-next-page') && getVisibleMatchingCount(pane) < visibleLimit) {
      const loadedPage = await loadNextProductsPage(section, pane);
      visibleLimit = parseInt(pane.getAttribute('data-visible-count'), 10) || getProductsToShow(section);

      if (!loadedPage) break;
    }
  }

  function applyFilter(pane, filter) {
    const filterBtns = Array.from(pane.querySelectorAll('.age-pane__subcat-btn'));

    if (filterBtns.length === 0) return;

    const normalizedFilter = filter && filter !== 'all' ? filter : 'all';
    const activeBtn = filterBtns.find(btn => !btn.hidden && btn.getAttribute('data-filter') === normalizedFilter) || filterBtns[0];
    const activeFilter = activeBtn ? activeBtn.getAttribute('data-filter') : 'all';

    filterBtns.forEach(btn => btn.classList.toggle('is-active', btn === activeBtn));
    pane.setAttribute('data-active-filter', activeFilter);
    pane.setAttribute('data-visible-count', String(getProductsToShow(pane.closest('.age-timeline-section'))));
    updateVisibleProducts(pane);
  }

  timelineSections.forEach(section => {
    const tabsNav = section.querySelector('.age-timeline__tabs-nav');
    const tabs = tabsNav ? Array.from(tabsNav.querySelectorAll('.age-timeline__tab-btn')) : [];
    const panes = Array.from(section.querySelectorAll('.age-timeline__tab-pane'));

    if (!tabsNav || tabs.length === 0 || panes.length === 0) return;

    const urlParams = new URLSearchParams(window.location.search);
    const initialAgeSlug = urlParams.get('age');
    const initialCatSlug = urlParams.get('cat');

    let activeTabIndex = 0;

    if (initialAgeSlug) {
      const foundIndex = tabs.findIndex(tab => tab.getAttribute('data-slug') === initialAgeSlug);
      if (foundIndex !== -1) {
        activeTabIndex = foundIndex;
      }
    }

    if (activeTabIndex > 0) {
      tabsNav.selectButton(tabs[activeTabIndex], false);
    }

    panes.forEach((pane, paneIndex) => {
      const filterBtns = Array.from(pane.querySelectorAll('.age-pane__subcat-btn'));
      const loadMoreBtn = pane.querySelector('.age-pane__load-more');

      pane.setAttribute('data-visible-count', String(getProductsToShow(section)));

      if (filterBtns.length === 0) return;

      updateFilterAvailability(pane);

      if (paneIndex === activeTabIndex && initialCatSlug && initialCatSlug !== 'all') {
        applyFilter(pane, initialCatSlug);
      } else {
        applyFilter(pane, 'all');
      }

      filterBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();

          const filter = btn.getAttribute('data-filter');
          applyFilter(pane, filter);
          ensureVisibleProducts(section, pane);
          setUrlParam('cat', filter);
        });
      });

      if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', () => {
          revealMoreProducts(section, pane);
        });
      }
    });

    tabsNav.addEventListener('tabs-nav:changed', (event) => {
      const selectedTab = event.detail.button;
      const selectedPane = document.getElementById(selectedTab.getAttribute('aria-controls'));

      if (!selectedPane) return;

      setUrlParam('age', selectedTab.getAttribute('data-slug'));
      setUrlParam('cat', 'all');
      applyFilter(selectedPane, 'all');
      ensureVisibleProducts(section, selectedPane);
    });

    ensureVisibleProducts(section, panes[activeTabIndex]);
  });
});
